<mat-card class="basicinfo-card" *ngIf="basicinfoForm">
  <div class="basicinfo-header">
    <h2 class="basicinfo-subtitle"><mat-icon class="basicinfo-icon">assignment_ind</mat-icon> Basic Information</h2>
  </div>
  <form class="basicinfo-form-container" [formGroup]="basicinfoForm">
    <div class="basicinfo-form-row">
      <mat-form-field appearance="outline">
        <mat-label>First Name</mat-label>
        <input matInput placeholder="First name" formControlName="firstName" />
        <mat-hint>Please fill First Name</mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Last Name</mat-label>
        <input matInput placeholder="Last Name" formControlName="lastName" />
        <mat-hint>Please fill Last Name</mat-hint>
      </mat-form-field>
    </div>
    <div class="basicinfo-form-row">
      <mat-form-field appearance="outline">
        <mat-label>Middle Name</mat-label>
        <input matInput placeholder="Middle name" formControlName="middleName" />
        <mat-hint>Please fill Middle Name</mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Gender</mat-label>
        <mat-select formControlName="gender">
          <mat-option *ngFor="let gender of genderTypes" [value]="gender">
            {{ gender.charAt(0).toUpperCase() + gender.substring(1).toLowerCase() }}
          </mat-option>
        </mat-select>
        <mat-hint>Please select gender</mat-hint>
      </mat-form-field>
    </div>
    <div class="basicinfo-form-row">
      <mat-form-field>
        <mat-label>Date of birthday</mat-label>
        <input matInput [matDatepicker]="picker" placeholder="Choose a date" formControlName="dob" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-hint>Please fill Birthday</mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Primary coverage</mat-label>
        <mat-select formControlName="primary_coverage_type">
          <mat-option *ngFor="let coverage of coverages" [value]="coverage">
            {{ coverage }}
          </mat-option>
        </mat-select>
        <mat-hint>Please select primary coverage</mat-hint>
      </mat-form-field>
    </div>
    <div class="basicinfo-form-row">
      <mat-form-field appearance="outline">
        <mat-label>Height(inches)</mat-label>
        <input matInput placeholder="Height" formControlName="height_inches" />
        <mat-hint>Please fill heights</mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Weight(lbs)</mat-label>
        <input matInput placeholder="Weight" formControlName="weight_lbs" />
        <mat-hint>Please fill weight</mat-hint>
      </mat-form-field>
    </div>
    <div class="basicinfo-form-row">
      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput placeholder="Email" formControlName="email" />
        <mat-hint *ngIf="showChangeEmailButton"
          >The 'Change email' button is enabled at the bottom of the form when the user changes the patient's
          email.</mat-hint
        >
        <mat-error *ngIf="basicinfoForm.get('email').errors?.email"
          >Please add a correct email. i.e welby&#64;welby.com</mat-error
        >
      </mat-form-field>
      <app-language-selector
        [languageInput]="basicinfoForm.get('language')"
        [languageModel]="languageModel"
      ></app-language-selector>
    </div>
    <div class="basicinfo-form-row" formGroupName="emr_data">
      <app-mrn-input
        class="mrn-input"
        [control]="basicinfoForm.get('emr_data.mrn')"
        [currentUserId]="patient.user_id"
        appearance="outline"
      >
      </app-mrn-input>
      <mat-form-field appearance="outline">
        <mat-label>EMR GUID</mat-label>
        <input matInput placeholder="EMR Guid" formControlName="emr_guid" />
        <mat-hint>EMR Guid (if different)</mat-hint>
      </mat-form-field>
    </div>

    <div class="basicinfo-form-row">
      <mat-form-field appearance="outline">
        <mat-label>HubSpot Id</mat-label>
        <input matInput placeholder="HubSpot Id" formControlName="hubspot_id" />
        <mat-hint>Please fill hubSpot Id</mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Client department</mat-label>
        <mat-select
          formControlName="client_department"
          matTooltip="The client doesn't have departments"
          matTooltipDisabled="{{ clientDepartments.length !== 0 }}"
        >
          <mat-option *ngFor="let department of clientDepartments" [value]="department.name">
            {{ department.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="basicinfo-form-row">
      <mat-form-field appearance="outline">
        <mat-label>Notes</mat-label>
        <textarea matInput placeholder="Notes" formControlName="notes" rows="4"></textarea>
        <mat-hint>Please fill Notes</mat-hint>
      </mat-form-field>
    </div>
    <div class="basicinfo-field-container">
      <h3>Providers</h3>
      <div class="basicinfo-form-row">
        <div>
          <ul *ngIf="patient.providers?.length > 0">
            <li matTooltip="{{ provider.email }}" *ngFor="let provider of patient.providers">
              <div fxLayout="row" fxLayoutGap=".5rem">
                <span>{{ provider.name }} - {{ provider.role }}</span>
                <mat-chip-list *ngIf="provider.rank === 1" class="small-mat-chip">
                  <mat-chip color="primary" matTooltip="Primary provider" selected>Primary</mat-chip>
                </mat-chip-list>
              </div>
            </li>
          </ul>
          <a (click)="openProviderPanel()" color="accent"><span class="patient-open-dialog">Add providers</span></a>
        </div>
      </div>
    </div>
    <div class="basicinfo-field-container">
      <h3>Programs Status</h3>
      <ng-container>
        <div class="basicinfo-form-row">
          <mat-form-field appearance="legacy">
            <input
              class="search-patient-input"
              type="text"
              placeholder="Add program"
              aria-describedby="Add program to patient"
              matInput
              formControlName="programInput"
              [matAutocomplete]="auto"
            />
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option
                *ngFor="let program of filteredProgramOptions$ | async"
                [value]="program?.value"
                (click)="selectProgram(program.value)"
              >
                <span>{{ program?.name }} ({{ program.value?.toUpperCase() }})</span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="basicinfo-form-row">
          <mat-form-field class="chip-list" appearance="fill">
            <mat-chip-list #chipList placeholder="Add programs">
              <mat-chip
                *ngFor="let program of programs"
                [selectable]="true"
                [removable]="true"
                matTooltip="{{ program.name }}"
                (removed)="removeProgram(program.value)"
                selected
              >
                {{ program?.value?.toUpperCase() }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
            </mat-chip-list>
          </mat-form-field>
        </div>
        <p class="noProgramsPar" *ngIf="basicinfoForm.get('status')?.errors?.noPrograms">Program is required</p>
        <p class="noProgramsPar" *ngIf="basicinfoForm.get('status')?.errors?.apcmConflict">
          APCM can't be selected with other CCM, PCM or TCM programs
        </p>
        <ng-container *ngIf="basicinfoForm.get('status')?.value?.apcm">
          <h3>APCM configuration</h3>
          <div class="basicinfo-form-row">
            <mat-form-field
              appearance="outline"
              formGroupName="status"
              matTooltip="APCM level just configured by Leads"
            >
              <mat-label>Level</mat-label>
              <mat-select formControlName="tier_apcm">
                <mat-option *ngFor="let tier of apcmTiers" [value]="tier.value">
                  {{ tier.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-container>
        <h3>Patient Status</h3>
        <ng-container formGroupName="status">
          <div class="basicinfo-form-row">
            <!-- Forced inactive-reason choice: engaged when all programs are removed from an active
                 patient (always mandatory; gated only by catalog presence). Blocks Save (required)
                 until a valid inactive reason is chosen. Otherwise the standard grouped dropdown. -->
            <mat-form-field *ngIf="showForcedInactiveChoice; else groupedStatus" appearance="outline">
              <mat-label>Inactive reason</mat-label>
              <mat-select
                formControlName="label"
                panelClass="status-groups-panel"
                [errorStateMatcher]="forcedInactiveErrorMatcher"
                required
              >
                <mat-option *ngFor="let item of forcedInactiveOptions; trackBy: trackByStatusKey" [value]="item.label">
                  <span class="status-dot status-dot--{{ statusDotClass(item.label) }}"></span>
                  {{ item.label }}
                </mat-option>
              </mat-select>
              <mat-hint>All programs were removed — select an inactive reason to save</mat-hint>
              <mat-error>Please select an inactive reason</mat-error>
            </mat-form-field>
            <ng-template #groupedStatus>
              <mat-form-field appearance="outline">
                <mat-label>Status</mat-label>
                <mat-select formControlName="label" panelClass="status-groups-panel">
                  <mat-select-trigger>{{ basicinfoForm.get('status')?.get('label')?.value }}</mat-select-trigger>
                  <!-- Hidden option carrying a deprecated/legacy/orphan stored label so mat-select
                       recognizes the value and displays it instead of rendering blank. -->
                  <mat-option *ngIf="unlistedStatusLabel" [value]="unlistedStatusLabel" [style.display]="'none'">
                    {{ unlistedStatusLabel }}
                  </mat-option>
                  <ng-container *ngFor="let group of statusGroups$ | async">
                    <div
                      class="status-group-header"
                      [class.status-group-header--open]="groupExpanded[group.label]"
                      (click)="toggleStatusGroup(group.label); $event.stopPropagation()"
                    >
                      <span class="status-dot status-dot--{{ statusDotClass(group.label) }}"></span>
                      <span class="status-group-header__label">{{ group.label }}</span>
                      <span class="status-group-header__count">{{ group.options.length }}</span>
                      <mat-icon class="status-group-header__chevron">chevron_right</mat-icon>
                    </div>
                    <!-- Keep options in the DOM and hide collapsed ones with CSS. Removing them via
                         *ngIf deregisters them from mat-select, which drops the current selection and
                         can leave the panel empty (unable to reopen). -->
                    <mat-option
                      *ngFor="let status of group.options; trackBy: trackByStatusLabel"
                      [value]="status"
                      [style.display]="groupExpanded[group.label] ? null : 'none'"
                    >
                      <span class="status-dot status-dot--{{ statusDotClass(status) }}"></span>
                      {{ status }}
                    </mat-option>
                  </ng-container>
                </mat-select>
                <mat-hint>Please select patient status</mat-hint>
              </mat-form-field>
            </ng-template>
          </div>
          <div
            class="basicinfo-form-row-on-hold"
            *ngIf="basicinfoForm.get('status')?.get('label')?.value === 'Active - On Hold'"
          >
            <mat-form-field>
              <mat-label>When does the patient expect to return?</mat-label>
              <input matInput [matDatepicker]="picker" placeholder="Choose a date" formControlName="dateOnHold" />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <div class="basicinfo-field-container">
      <h3>Direct Referral</h3>
      <div class="basicinfo-form-row">
        <mat-slide-toggle color="primary" labelPosition="before" formControlName="direct_referral">
          Direct Referral
        </mat-slide-toggle>
        <span *ngIf="patient.direct_referral === true && patient.direct_referral_date">{{
          patient.direct_referral_date?.seconds * 1000 | date
        }}</span>
      </div>
    </div>
    <div class="basicinfo-field-container" *ngIf="basicinfoForm.get('gender').value === 'female'">
      <div class="label-ob-program">
        <h3>OB Program</h3>
        <mat-chip-list
          *ngIf="
            basicinfoForm.get('isPregnant').value &&
            this.patient?.isPregnant &&
            this.patient?.start_last_pregnancy?.toDate
          "
          class="small-mat-chip"
        >
          <mat-chip [color]="chipColor" selected matTooltip="Time in the program">
            {{ chipLabel }}
          </mat-chip>
        </mat-chip-list>
      </div>

      <div class="basicinfo-form-row">
        <mat-slide-toggle color="primary" labelPosition="before" formControlName="isPregnant">
          Is in OB program
        </mat-slide-toggle>
      </div>
      <span
        class="basicinfo-pregnant-text"
        *ngIf="
          basicinfoForm.get('isPregnant').value &&
          this.patient?.isPregnant &&
          this.patient?.start_last_pregnancy?.toDate
        "
        >Start date: {{ this.patient?.start_last_pregnancy?.toDate() | date }}</span
      >
    </div>
    <div class="basicinfo-field-container">
      <h3>Patient time zone</h3>
      <div class="basicinfo-form-row">
        <app-timezone-picker [customPlaceholderText]="'Choose time zone'" [formControlName]="'timezone'">
        </app-timezone-picker>
      </div>
    </div>
    <div class="basicinfo-field-container">
      <h3>Contact Consent</h3>
      <div formGroupName="contact_consent" class="basicinfo-form-row">
        <mat-slide-toggle color="primary" labelPosition="before" formControlName="email"> Email </mat-slide-toggle>
        <mat-slide-toggle color="primary" labelPosition="before" formControlName="phone"> Phone </mat-slide-toggle>
        <mat-slide-toggle color="primary" labelPosition="before" formControlName="sms"> SMS </mat-slide-toggle>
      </div>
    </div>
    <div class="basicinfo-field-container" *ngIf="patient.status?.ccm">
      <h3>CCM to APCM transition consent</h3>
      <div class="basicinfo-form-row">
        <mat-slide-toggle color="primary" labelPosition="before" formControlName="ccm_to_apcm_consent">
          CCM to APCM Consent
        </mat-slide-toggle>
        <span *ngIf="patient.ccm_to_apcm_consent?.consent === true">{{
          patient.ccm_to_apcm_consent?.consent_date?.seconds * 1000 | date
        }}</span>
      </div>
    </div>
  </form>
  <div class="basicinfo-form-row save-button">
    <button
      mat-raised-button
      *ngIf="showChangeEmailButton"
      color="accent"
      [disabled]="!showChangeEmailButton"
      (click)="openChangeEmailDialog()"
    >
      <mat-icon>email</mat-icon> Change Email
    </button>
    <button
      mat-raised-button
      color="primary"
      [disabled]="basicinfoForm.invalid || !statusConfigLoaded"
      (click)="saveBasicInfo()"
    >
      Save
    </button>
  </div>
</mat-card>
